import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { UtilService } from 'src/app/api/services/util.service';

/**
 * Resolver to evaluate established connection to SPIN in Commerce Case Routing
 */
export const competitionAuthorResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot
) => {
  return inject(UtilService).isLoggedCompetitorAnOrganizer(
    route.parent?.paramMap.get('id') as unknown as number
  );
};
